import { getUrl, Post, Get, Put, Patch } from ".";

export const SearchByCode = async (body) => {
  return Post(getUrl('cnps.location.search-by-code'), body);
}
